import React from 'react';
import { Pressable, View } from 'react-native';

import { ThemedText } from '@/components/ThemedText';
import { ThemedView } from '@/components/ThemedView';
import AppStyles from '@/constants/Styles';
import { useThemeColor } from '@/hooks/useThemeColor';
import { PollingStation } from '@/types/polling_station';

interface PollingStationItemProps {
  pollingStation: PollingStation;
  onPress?: (pollingStation: PollingStation) => void;
  style?: any;
}

function PollingStationItem({ 
  pollingStation, 
  onPress,
  style
}: PollingStationItemProps) {
  // Theme-aware colors from Colors.ts
  const borderColor = useThemeColor({}, 'border');
  const statsTextColor = useThemeColor({}, 'secondaryText');
  const cardBackgroundColor = useThemeColor({}, 'cardBackground');

  const handlePress = () => {
    if (onPress) {
      onPress(pollingStation);
    }
  };

  return (
    <ThemedView 
      style={[
        AppStyles.engagementItem, 
        { 
          marginBottom: 12, 
          borderWidth: 1, 
          borderColor, 
          backgroundColor: cardBackgroundColor 
        }, 
        style
      ]} 
    >
      <Pressable 
        style={{ flex: 1 }} 
        onPress={handlePress}
      >
        <View style={{ flex: 1 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
            <View style={{ flex: 1 }}>
              <ThemedText style={AppStyles.engagementName}>
                {pollingStation.station_name}
              </ThemedText>
            </View>
            <ThemedText style={{ color: statsTextColor, fontSize: 12 }}>
              {pollingStation.voter_count} voters
            </ThemedText>
          </View>
          
          <View style={{ marginTop: 4 }}>
            <ThemedText style={{ color: statsTextColor, fontSize: 14 }}>
              {pollingStation.address}
            </ThemedText>
            {pollingStation.postcode && (
              <ThemedText style={{ color: statsTextColor, fontSize: 14, marginTop: 2 }}>
                {pollingStation.postcode}
              </ThemedText>
            )}
            {pollingStation.polling_station_districts && pollingStation.polling_station_districts.length > 0 && (
              <ThemedText style={{ color: statsTextColor, fontSize: 12, marginTop: 4 }}>
                Districts: {pollingStation.polling_station_districts?.map(e => e.polling_district).join(', ') || 'N/A'}
              </ThemedText>
            )}
          </View>
        </View>
      </Pressable>
    </ThemedView>
  );
}

// Memoize the component to prevent unnecessary re-renders
export default React.memo(PollingStationItem);

